
export const reducerClipboardCancel = (state) => {
    return {
        ...state,
        helpers: {
            ...state.helpers,
            clipboard: null,
        },
    };
};